export default "__VITE_ASSET__YRS_NVjW__"